import { createFeatureSelector, createSelector } from '@ngrx/store';

import { HelloResultsState } from './hello-results.models';
import { defaultLocale } from './hello-results.reducers';

const selectHelloResultsState = createFeatureSelector<HelloResultsState>('helloResults');

export const selectDayOfWeek = createSelector(selectHelloResultsState, state => state?.DayOfWeek || 0);

export const selectDateLocale = createSelector(selectHelloResultsState, state => state?.dateLocale || defaultLocale);
